import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  _id: null,
  p_name: null,
  p_icon: null,
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    addProfile: (state, action) => {
      state._id = action.payload._id;
      state.p_name = action.payload.p_name;
      state.p_icon = action.payload.p_icon;
    },
    removeProfile: (state) => {
      state._id = null;
      state.p_name = null;
      state.p_icon = null;
    },
  },
});

export const { addProfile, removeProfile } = profileSlice.actions;
export default profileSlice.reducer;
